/*
  HyperCrate annotated plate callouts.

  Pairs a numbered disc sitting over a UI screenshot with its entry in the
  legend underneath, so hovering or focusing either one lights both. Ported
  from the in-app manual's callout behaviour (docs/manual/build/template/manual.js)
  and cut down: the manual pins on click because it is a reference document you
  read one entry at a time; here a landing-page visitor is scanning, so hover
  and focus are enough and a click simply toggles.

  The markup is authored by the Liquid section and is complete on its own: the
  legend reads as an ordinary numbered list with no script running at all. This
  file only adds the cross-highlighting.
*/
(function () {
  'use strict'

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

  function boot (root) {
    if (root.dataset.hcpWired) return
    root.dataset.hcpWired = '1'

    var discs = root.querySelectorAll('.hcp__disc')
    var rings = root.querySelectorAll('.hcp__ring')
    var entries = root.querySelectorAll('.hcp__entry')
    if (!discs.length) return

    var pinned = null

    function apply (n) {
      /* n is the 1-based callout index, or null for "nothing active". */
      root.classList.toggle('is-live', n !== null)
      var i
      for (i = 0; i < discs.length; i++) set(discs[i], n)
      for (i = 0; i < rings.length; i++) set(rings[i], n)
      for (i = 0; i < entries.length; i++) set(entries[i], n)
    }

    function set (el, n) {
      el.classList.toggle('is-on', n !== null && el.dataset.n === String(n))
    }

    function enter (n) { apply(n) }
    function leave () { apply(pinned) }

    function toggle (n) {
      pinned = pinned === n ? null : n
      apply(pinned)
    }

    function wire (el) {
      var n = Number(el.dataset.n)
      el.addEventListener('mouseenter', function () { enter(n) })
      el.addEventListener('mouseleave', leave)
      el.addEventListener('focus', function () { enter(n) })
      el.addEventListener('blur', leave)
      el.addEventListener('click', function () { toggle(n) })
    }

    var i
    for (i = 0; i < discs.length; i++) wire(discs[i])
    for (i = 0; i < entries.length; i++) wire(entries[i])

    if (reduced) root.classList.add('hcp--reduced')
  }

  function bootAll () {
    var plates = document.querySelectorAll('[data-hc-plate]')
    for (var i = 0; i < plates.length; i++) boot(plates[i])
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll)
  } else {
    bootAll()
  }

  /* Theme editor re-renders a section without a full page load. */
  document.addEventListener('shopify:section:load', bootAll)

  window.hcPlateCallouts = bootAll
})()
